import { useEffect } from 'react';
import { API } from './api';
import { pushToDataLayer } from './analytics';

const AFFILIATE_HOSTS = ['tidd.ly', 'shop.centr.com', 'awin1.com'];

/** Fires a beacon to /analytics/track whenever any affiliate link is clicked (capture phase, survives navigation). */
export function useAffiliateClickTracking() {
  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      const href = a.href || '';
      if (!AFFILIATE_HOSTS.some((h) => href.includes(h))) return;
      const w = window.innerWidth;
      const payload = {
        event_name: 'affiliate_click',
        source_page: window.location.pathname,
        element_id: a.getAttribute('title') || (a.textContent || '').trim().slice(0, 80) || 'affiliate-link',
        destination: href,
        device_type: w < 768 ? 'mobile' : w < 1024 ? 'tablet' : 'desktop',
        referrer: document.referrer || '',
      };
      pushToDataLayer('affiliate_click', {
        destination: href,
        product_name: payload.element_id,
        source_page: payload.source_page,
        device_type: payload.device_type,
      });
      try {
        const sent = navigator.sendBeacon?.(
          `${API}/analytics/track`,
          new Blob([JSON.stringify(payload)], { type: 'application/json' })
        );
        if (!sent) {
          fetch(`${API}/analytics/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: true,
          }).catch(() => {});
        }
      } catch { /* analytics must never break navigation */ }
    };
    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, []);
}
